import { ProductBillingType } from "../../Products";
import { VendorCompany, VendorSubscriptionStatus } from "../Vendor";

export enum MarketplaceCategory {
	PRODUCTIVITY = "productivity",
	INFRASTRUCTURE = "infrastructure",
	CONTINUITY = "continuity",
	SECURITY = "security",
	COMMUNICATION = "communication",
	COMPLIANCE = "compliance",
	TRAINING = "training",
	BILLING_AUTOMATION = "billing_automation"
}

export const MarketplaceSubcategory = {
	[MarketplaceCategory.PRODUCTIVITY]: [
		"Email Service",
		"Business Applications",
		"Business Intelligence",
		"Commnucations",
		"MSP Tools",
		"Productivity Monitoring",
		"Project Management",
		"Distributed Spend Management",
		"Travel Management",
		"Financial Reporting & Analytics",
		"RPA",
		"Customer Experience",
		"Automation",
		"Data Collaboration"
	],
	[MarketplaceCategory.COMMUNICATION]: [
		"Unified Communications",
		"Contact Centre"
	],
	[MarketplaceCategory.INFRASTRUCTURE]: [
		"laaS",
		"Storage",
		"DaaS",
		"laaS DaaS Management",
		"laaS Migration"
	],
	[MarketplaceCategory.CONTINUITY]: [
		"Email Archiving",
		"High Availability",
		"Disaster Recovery",
		"File Sharing",
		"SaaS Backup",
		"Backup"
	],
	[MarketplaceCategory.SECURITY]: [
		"Security Assessment",
		"Data Protection & Compliance",
		"Email Security",
		"Managed Security",
		"Moblile Security",
		"Network Security",
		"Endpoint Security",
		"Web Security",
		"Identity Managment",
		"Security Training"
	]
};

export class MarketplaceProductCountMap {
	[MarketplaceCategory.PRODUCTIVITY] = 0;
	[MarketplaceCategory.INFRASTRUCTURE] = 0;
	[MarketplaceCategory.CONTINUITY] = 0;
	[MarketplaceCategory.SECURITY] = 0;
	[MarketplaceCategory.COMMUNICATION] = 0;
	[MarketplaceCategory.COMPLIANCE] = 0;
	[MarketplaceCategory.TRAINING] = 0;
	[MarketplaceCategory.BILLING_AUTOMATION] = 0;
}

export enum MarketplaceProductBillingTerms {
	USAGE = "usage",
	LICENSE = "license"
}

export enum MarketplacePricingPlanType {
	FLAT_PRICING = "flat_pricing",
	TIER_BASED_PRICING = "tier_based_pricing",
	VOLUME_BASED_PRICING = "volume_based_pricing"
}

export enum MarketplaceProductPricingUOM {
	USER = "user",
	ENVIRONMENT = "environment",
	DATA = "data",
	RESOURCE = "resource"
}

export class MarketplaceProductPricingPlanTierDetails {
	cost_to_msp = 0;
	cost_to_end_user = 0;
	starting_unit = 0;
	ending_unit = 0;
}

export class MarketplaceProductPricingPlanV2 {
	cost_to_end_user = 0;
	cost_to_msp = 0;
	plan_type: MarketplacePricingPlanType =
		MarketplacePricingPlanType.FLAT_PRICING;
	tier_level: MarketplaceProductPricingPlanTierDetails[] = [];
}

class MarketplaceProductPricingTrialPeriod {
	days: number | null = null;
	price: number | null = null;
	constructor(noOfDays: number | null, price: number | null) {
		this.days = noOfDays;
		this.price = price;
	}
}

export class MarketplaceProductPricingTierCostDetails {
	cost_to_msp = 0;
	cost_to_end_user = 0;
	setup_price?: number;
}

export class MarketplaceProductPricingTierDetailsRequest {
	starting_unit = 0;
	ending_unit = 0;
	cost_detail: MarketplaceProductPricingTierCostDetails =
		new MarketplaceProductPricingTierCostDetails();
}

export class MarketplaceProductPricingTierRequest {
	tier_details: MarketplaceProductPricingTierDetailsRequest[] = [];
}

export class MarketplaceProductPricingFlatPricingRequest {
	cost_detail: MarketplaceProductPricingTierCostDetails =
		new MarketplaceProductPricingTierCostDetails();
}

export class MarketplaceProductPricingRequest {
	plan_type: MarketplacePricingPlanType =
		MarketplacePricingPlanType.FLAT_PRICING;
	data:
		| MarketplaceProductPricingTierRequest
		| MarketplaceProductPricingFlatPricingRequest =
		new MarketplaceProductPricingFlatPricingRequest();
}

export class MarketplaceProductPricing {
	additional_benefits: string | null = null;
	features: string[] = [];
	created: Date = new Date();
	id = "";
	item_id = ""; // refers to marketplace listing id
	name = "";
	plan_details: MarketplaceProductPricingRequest =
		new MarketplaceProductPricingRequest();
	should_show_trial_price = false;
	trial_period: MarketplaceProductPricingTrialPeriod | null = null;
	uom: MarketplaceProductPricingUOM = MarketplaceProductPricingUOM.USER;
	updated: Date = new Date();
	billing_period: ProductBillingType = ProductBillingType.OneTime;
}

export class MarketplaceProduct {
	billing_terms: MarketplaceProductBillingTerms =
		MarketplaceProductBillingTerms.USAGE;
	category: MarketplaceCategory = MarketplaceCategory.PRODUCTIVITY;
	created: Date = new Date();
	description = "";
	gdpr_status = false;
	hipaa_status = false;
	id = "";
	images: string[] = [];
	key_points: string[] = [];
	name = "";
	pci_status = false;
	pricings: MarketplaceProductPricing[] = [];
	screenshots: string[] = [];
	sub_category: string[] = [];
	thumbnail?: string = undefined;
	updated: Date = new Date();
	videos: string[] = [];
	vendor_details: VendorCompany = new VendorCompany();
	is_active = true;
	subscription_status = VendorSubscriptionStatus.NOTAPPLIED;
}

export class MarketplaceProductsResponse {
	data: MarketplaceProduct[] = new Array<MarketplaceProduct>();
	filtered_count_map: MarketplaceProductCountMap =
		new MarketplaceProductCountMap();
}

export enum MarketplaceProductCompliance {
	GDPR = "gdpr",
	PCI = "pci",
	HIPAA = "hipaa"
}

export const MarketplaceProductBillingTermsRadioOptions = [
	{
		label: "Usage",
		value: MarketplaceProductBillingTerms.USAGE
	},
	{
		label: "License",
		value: MarketplaceProductBillingTerms.LICENSE
	}
];
